import {
  pendingTask, // The action key for modifying loading state
  begin, // The action value if a "long" running task begun
  end, // The action value if a "long" running task ended
  endAll // The action value if all running tasks must end
} from "react-redux-spinner";

import { START_LOADING, STOP_LOADING, STOP_ALL_LOADING } from "./constants";

export const startLoadingAction = {
  type: START_LOADING,
  [pendingTask]: begin
};

export const stopLoadingAction = {
  type: STOP_LOADING,
  [pendingTask]: end
};

export const stopAllLoadingAction = {
  type: STOP_ALL_LOADING,
  [pendingTask]: endAll
};
